<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <OnRatiosEmploisAgency :agencyId="f_agency_id" />
      </div>
    </div>
  </div>
</template>

<script>
import OnRatiosEmploisAgency from '@/components/OnRatiosEmploisAgency.vue'

export default {
  name: 'OnRatiosEmploisAgencyNm',
  components: {
    OnRatiosEmploisAgency
  },
  data() { return {
    f_agency_id : this.$route.params.agency_id
  }}
}

</script>